import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { type } from "@testing-library/user-event/dist/type";
import Checkbox from "@mui/material/Checkbox";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import {
  get_YMD_from_SYS,
  getRowColData,
  validatedate_min_max,
  isValidItem,
  get_30DaysBack_FromCurrentDate,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  getlocalstoragedate,
  setlocalstoragedate,
} from "../SystemUtility/SystemUtility";
import FormControlLabel from "@mui/material/FormControlLabel";
import { apiURL, fetchAccountDetail, fetchLedgerMaster } from "./API";
import ResetDate from "../images/resetdate.png";

class AccountBookReport extends Component {
  state = {
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
      cmbGroupName: "",
      cmbType: "Summary",
      cmbName: "",
      chekNewpage: false,
      cmbLedgerGroup: "",
      cmbGroupName: "",
      cmbGroupNameDisabled: false,
    },
    cmbTypeNames: [{ Types: "Summary" }, { Types: "Detail" }],
    cmbNameItems: [],
    LedgerNameList: [],
    RptType: "",
  };

  //#region Component
  componentDidMount() {
    let RptType = this.props.params.Book.substring(1);
    document.title = "RiTe Account : " + RptType + " Book Report";
    this.props.setActiveMenu("AccountBookReport");
    this.props.verifyUserID(
      this.onFormLoad,
      this.setRptType(RptType, this.loadNameItems),
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  componentWillReceiveProps(newprops) {
    if (newprops.params.Book && newprops.params.Book !== this.state.RptType) {
      this.setRptType(newprops.params.Book.substring(1));
    }
  }
  //#endregion Component

  //#region Handles
  handleOnChange = (e) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
  };
  //#endregion Handles

  //#region Function

  setRptType = (RptType, nextFunctionCall = undefined) => {
    this.setState(
      {
        RptType,
        formData: {
          ...this.state.formData,
          cmbGroupName: RptType !== "Ledger" ? RptType : "",
          cmbGroupNameDisabled:
            RptType === "Ledger" || RptType === "Supplier" ? false : true,
          cmbName: "",
        },
      },
      () => {
        if (nextFunctionCall) {
          nextFunctionCall();
        }
        document.title = "RiTe Account : " + RptType + " Book Report";
        document.getElementById("dtpFromDate").focus();
      }
    );
  };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "LedgerBookReport",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      // window.location.reload();
      this.onFormLoad(reset);
      document.getElementById("dtpFromDate").focus();
    }
  };

  onFormLoad = (reset = false) => {
    const { fromdate, todate } = getlocalstoragedate("LedgerBookReport");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        this.loadNameItems();
        document.getElementById("dtpFromDate").focus();
      }
    );
  };

  loadNameItems = () => {
    // console.log("this.props.params.Book", this.props.params.Book);
    let reqData = "",
      Op = "",
      cmbGroupName = "";
    if (this.getRptType() === "Customer") {
      Op = "LedgerNameList";
      cmbGroupName = "Customer";
    } else if (this.getRptType() === "Supplier") {
      Op = "LedgerNameList";
      cmbGroupName = "Supplier";
    } else {
      Op = "LedgerNameList";
      cmbGroupName = "";
    }
    reqData = {
      Op,
      bint_acid: localStorage.getItem("acid"),
    };
    fetchLedgerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        this.setState({
          cmbNameItems: getRowColData(res.data.LedgerNameList, "vac_groupname"),
          LedgerNameList: res.data.LedgerNameList,
          formData: { ...this.state.formData, cmbGroupName },
        });
      })
      .catch((err) => {
        console.log("Unknown error occurred in getInfo.", err);
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in loading . " + err
        );
      });
    document.getElementById("dtpFromDate").focus();
  };

  getRptType = () => {
    return this.state.RptType;
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["cmbGroupName"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validate = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;

    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else if (this.state.formData.cmbType.length <= 0) {
      this.props.toastErrorMsg("Select Type", "cmbType");
    } else if (
      !isValidItem(
        this.state.cmbTypeNames,
        "Types",
        this.state.formData.cmbType
      )
    ) {
      this.props.toastErrorMsg("Select Valid Type", "cmbType");
    } else if (
      this.state.formData.cmbGroupName.length > 0 &&
      !isValidItem(
        this.state.cmbNameItems,
        "vac_groupname",
        this.state.formData.cmbGroupName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Group Name", "cmbGroupName");
    } else if (this.state.formData.cmbName.length <= 0) {
      this.props.toastErrorMsg("Select Name", "cmbName");
    } else if (
      !isValidItem(
        this.state.LedgerNameList,
        "vac_ledgername",
        this.state.formData.cmbName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Name", "cmbName");
    } else {
      result = true;
    }
    return result;
  };

  reqDataForReport = (bolChkDataExist) => {
    return {
      Op: "BookReport",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      dat_fromdate: this.state.formData.dtpFromDate,
      dat_todate: this.state.formData.dtpToDate,
      DataType: this.getRptType(),
      ReportType: this.state.formData.cmbType,
      bolChkDataExist: bolChkDataExist,
      vac_groupname: this.state.formData.cmbGroupName,
      vac_ledgername: this.state.formData.cmbName,
    };
  };

  openAccountBookReport = () => {
    if (this.validate()) {
      this.props.notifyProcessing();
      let reqData = this.reqDataForReport(true);
      fetchAccountDetail(reqData)
        .then((res) => {
          if (res.data.msgType === "info") {
            let reqData = this.reqDataForReport(false);
            let params = new URLSearchParams(reqData);
            let popupURL =
              apiURL + "accountreportdetail.php?" + params.toString();
            window.open(
              popupURL,
              "BookReport",
              "width=" +
                window.screen.availWidth +
                ",height=" +
                window.screen.availHeight
            );
            this.props.updateProcessing("success", "PDF Open in popup.");
          } else {
            this.props.updateProcessing(res.data.msgType, res.data.message);
          }
        })
        .catch((error) => {
          console.log(
            "Unknown error occurred in openAccountBookReport.",
            error
          );
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in loading . " + error
          );
        });
      document.getElementById("dtpFromDate").focus();
      // Create a query string from the request data
    }
  };
  //#endregion Function

  render() {
    return (
      <form>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>{this.getRptType()} Book Report</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={3}
              marginTop={0}
            >
              <Grid item>
                <CardContent>
                  <CardMedia
                    component="img"
                    alt="Reset Date to Default"
                    sx={{ width: 35 }}
                    image={ResetDate}
                    onClick={() => {
                      this.setfrom_todate(true);
                    }}
                  />
                </CardContent>
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date*"
                  width="120"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date*"
                  width="120"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbType"
                  accountYear={localStorage.getItem("ACY")}
                  // F={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={3}
                marginTop={0}
              >
                <Grid item>
                  <CtCmbEditable
                    id="cmbType"
                    label="Type*"
                    items={this.state.cmbTypeNames}
                    colID="Types"
                    value={this.state.formData.cmbType}
                    handleOnChange={this.handleOnChange}
                    width={360}
                    maxLength={50}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID={
                      this.state.formData.cmbGroupNameDisabled != true
                        ? "cmbGroupName"
                        : "cmbName"
                    }
                    // disabled={this.state.formData.cmbGroupNameDisabled}
                  />
                </Grid>
                <Grid item>
                  <CtCmbEditable
                    id="cmbGroupName"
                    label="Group Name"
                    items={this.state.cmbNameItems}
                    colID="vac_groupname"
                    value={this.state.formData.cmbGroupName}
                    handleOnChange={this.handleOnChange}
                    width={360}
                    maxLength={50}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="cmbName"
                  />
                </Grid>
                <Grid item>
                  <CtCmbEditable
                    id="cmbName"
                    label="Name*"
                    colID="vac_ledgername"
                    items={this.state.LedgerNameList}
                    width={360}
                    value={this.state.formData.cmbName}
                    handleOnChange={this.handleOnChange}
                    maxLength={50}
                    dataFilter={[
                      {
                        filterColID: "vac_groupname",
                        value: this.state.formData.cmbGroupName,
                      },
                    ]}
                    onKeyDown={this.props.onKeyDown}
                    defaultAction={this.openAccountBookReport}
                  />
                </Grid>
                <Grid item>
                  <CtBtn
                    label="PDF"
                    onClick={() => {
                      this.trimFormData(() => {
                        this.openAccountBookReport();
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(AccountBookReport))));
